import {StyleParamType, wixColorParam, createStylesParams} from '@wix/tpa-settings'

export type BackgroundAndBordersStylesParams = {
  backgroundAndBordersAppBackgroundColor: StyleParamType.Color
  backgroundAndBordersCardBackgroundColor: StyleParamType.Color
  backgroundAndBordersCardBorderWidth: StyleParamType.Number
  backgroundAndBordersCardBorderColor: StyleParamType.Color
  backgroundAndBordersCardCornerRadiusTopLeft: StyleParamType.Number
  backgroundAndBordersCardCornerRadiusTopRight: StyleParamType.Number
  backgroundAndBordersCardCornerRadiusBottomLeft: StyleParamType.Number
  backgroundAndBordersCardCornerRadiusBottomRight: StyleParamType.Number
}

export const backgroundAndBordersStylesParams =
  createStylesParams<BackgroundAndBordersStylesParams>({
    backgroundAndBordersAppBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
    },
    backgroundAndBordersCardBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 0.1),
    },
    backgroundAndBordersCardBorderWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    backgroundAndBordersCardBorderColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-37', 0.12),
    },
    backgroundAndBordersCardCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    backgroundAndBordersCardCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    backgroundAndBordersCardCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    backgroundAndBordersCardCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
  })
